import type { FC } from "react";

import { Column, Row } from "@jti/core-components/components/Row";
import { type Address } from "@jti/fe-common";
import { AddressStreetInfo, useTranslations } from "@jti/ui";

import styles from "./ShippingDataOverview.module.scss";

type ShippingDataOverviewProps = {
  firstName: string;
  lastName: string;
  telephone: string;
  address: Address;
  deliveryOptionName: string;
  fiscalCode?: string;
};

export const ShippingDataOverview: FC<ShippingDataOverviewProps> = ({
  firstName,
  lastName,
  telephone,
  address,
  deliveryOptionName,
  fiscalCode,
}) => {
  const { __ } = useTranslations();

  return (
    <div className={styles.container}>
      <Row className={styles.row}>
        <Column xs={12} md={6} className={styles.column}>
          <h4 className={styles.sectionTitle}>{__("cart.checkout.shipping_contact.title")}</h4>
          <p className={styles.sectionText}>{__("cart.checkout.shipping_contact.name", [firstName, lastName])}</p>
          <p className={styles.sectionText}>{telephone}</p>
          {!!fiscalCode && <p className={styles.sectionText}>{fiscalCode}</p>}
        </Column>

        <Column xs={12} md={6} className={styles.column}>
          <h4 className={styles.sectionTitle}>{__("cart.checkout.shipping_address.title")}</h4>
          <AddressStreetInfo address={address} />
        </Column>
      </Row>
      <Row className={styles.row}>
        <Column xs={12} className={styles.column}>
          <h4 className={styles.sectionTitle}>{__("cart.checkout.shipping_options.title")}</h4>
          <p className={styles.sectionText}>{deliveryOptionName}</p>
        </Column>
      </Row>
    </div>
  );
};
